import { useAccountInfo } from '../api/queryHooks/account';
import type { FeatureKey } from '../api/featureKeys';

/** True iff the current account has the given feature enabled. */
export function useFeature(key: FeatureKey): boolean {
  const { data } = useAccountInfo();
  return data?.permissions?.includes(key) ?? false;
}
